<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Create new Announcement
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-alert
      variant="primary"
      show
    >
      <div class="alert-body">
        <span class="weight-400"><strong class="weight-700">For Nirvana Agent SG:</strong> This is the control panel where administrators can edit the content for the agent-facing mobile app.</span>
      </div>
    </b-alert>
    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="announcementCreateForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Title*"
                label-for="h-announcement-title"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Title"
                  vid="title"
                  rules="required"
                >
                  <b-form-input
                    id="h-announcement-title"
                    v-model="title"
                    placeholder="Type the announcement title"
                    :state="(errors.length > 0 || titleValidation) ? false : null"
                    name="title"
                    @input="titleValidation == true ? titleValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="titleValidation"
                    class="text-danger"
                  >
                    {{ titleError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Category"
                vid="category"
                rules="required"
              >
                <b-form-group
                  label="Category*"
                  label-for="h-announcement-category"
                  label-cols-md="2"
                  :state="(errors.length > 0 || categoryValidation) ? false : null"
                >
                  <v-select
                    id="h-announcement-category"
                    v-model="category"
                    label="name"
                    multiple
                    placeholder="Select category"
                    :options="categoryOptions"
                    :reduce="name => name._id"
                    :clearable="true"
                    @input="categoryValidation == true ? categoryValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="categoryValidation"
                    class="text-danger"
                  >
                    {{ categoryError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Push To"
                vid="user"
                rules="required"
              >
                <b-form-group
                  label="Push To*"
                  label-for="h-announcement-user"
                  label-cols-md="2"
                  :state="(errors.length > 0 || userValidation) ? false : null"
                >
                  <v-select
                    id="h-announcement-user"
                    v-model="toAgents"
                    label="name"
                    multiple
                    placeholder="Select who do you want to push to"
                    :options="rankOptions"
                    :clearable="true"
                    @input="toAgentsValidation == true ? toAgentsValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="toAgentsValidation"
                    class="text-danger"
                  >
                    {{ toAgentsError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Published by"
                vid="department"
                rules="required"
              >
                <b-form-group
                  label="Published by*"
                  label-for="h-announcement-department"
                  label-cols-md="2"
                  :state="(errors.length > 0 || departmentValidation) ? false : null"
                >
                  <v-select
                    id="h-announcement-department"
                    v-model="department"
                    label="name"
                    multiple
                    placeholder="Select your department"
                    :options="departmentOptions"
                    :reduce="name => name._id"
                    :clearable="true"
                    @input="departmentValidation == true ? departmentValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="departmentValidation"
                    class="text-danger"
                  >
                    {{ departmentError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-12">
              <b-form-group
                label="Show In Highlights?*"
                label-for="h-activity-type-highlight"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Show In Highlights"
                  vid="highlight"
                  rules="required"
                >
                  <b-form-radio-group
                    id="h-activity-type-highlight"
                    v-model="highlight"
                    button-variant="outline-primary"
                    buttons
                    class="spaceBetweenRadio"
                  >
                    <b-form-radio
                      v-for="(option, kindex) in requiredOptions"
                      :key="kindex"
                      :value="option.value"
                    >
                      <feather-icon
                        v-if="highlight === option.value"
                        icon="CheckIcon"
                        class="mr-50"
                        size="16"
                      />
                      <span class="align-middle">{{ option.text }}</span>
                    </b-form-radio>
                  </b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <template v-if="highlight == 'yes'">
              <b-col
                md="12"
                class="my-2"
              >
                <b-form-group
                  label="Highlight Image*"
                  label-cols-md="2"
                  label-for="image"
                >
                  <div class="d-flex justify-content-start">
                    <div
                      class="image__block"
                    >
                      <b-img
                        class="mb-1 mb-sm-0 user__avatar img-preview-block wh-100"
                        :src="fileSrc ? fileSrc : defaultImage"
                      />
                    </div>

                    <div
                      class="upload__buttons my-auto mx-2"
                    >
                      <b-form-file
                        ref="fileInput"
                        v-model="image"
                        type="file"
                        accept="image/jpeg, image/jpg, image/png"
                        style="display: none"
                        @input="setImage"
                      />
                      <b-button
                        variant="primary"
                        class="mr-50"
                        @click="$refs.fileInput.$el.childNodes[0].click()"
                      >
                        Upload
                      </b-button>
                      <b-button
                        v-if="fileSrc"
                        variant="outline-primary"
                        class="mr-50"
                        @click="removeFileSrc()"
                      >
                        Remove
                      </b-button>
                      <br>
                      <span class="mt-50 d-block">Uploading an image is required for highlighted announcements. The image should not exceed 10 MB and must be in JPEG or PNG format. For the best results, use dimensions of 736px width by 420px height.</span>
                    </div>
                  </div>
                  <small class="text-danger">{{ fileError }}</small>
                </b-form-group>
              </b-col>
              <b-col cols="md-6">
                <b-form-group
                  label="Highlight from*"
                  label-for="h-event-start"
                  label-cols-md="4"
                >
                  <b-input-group>
                    <flat-pickr
                      id="h-event-start"
                      v-model="start"
                      placeholder="Leave blank to display immediately"
                      class="form-control flat-pickr-group"
                      :config="{ wrap: true, enableTime: true, dateFormat: 'd/m/Y, H:i', minDate: 'today', disableMobile: true }"
                      @input="startValidation == true ? startValidation = false : null"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        icon="CalendarIcon"
                        class="cursor-pointer"
                        data-toggle
                        size="18"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small
                    v-if="startValidation"
                    class="text-danger"
                  >
                    {{ startError }}
                  </small>
                </b-form-group>
              </b-col>
              <b-col cols="md-6" />

              <b-col cols="md-6">
                <b-form-group
                  label="Highlight till*"
                  label-for="h-event-end"
                  label-cols-md="4"
                >
                  <b-input-group>
                    <flat-pickr
                      id="h-event-end"
                      v-model="end"
                      placeholder="Leave blank to display forever"
                      class="form-control flat-pickr-group"
                      :config="{ wrap: true, enableTime: true, dateFormat: 'd/m/Y, H:i', minDate: 'today', disableMobile: true }"
                      @input="endValidation == true ? endValidation = false : null"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        icon="CalendarIcon"
                        class="cursor-pointer"
                        data-toggle
                        size="18"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small
                    v-if="endValidation"
                    class="text-danger"
                  >
                    {{ endError }}
                  </small>
                </b-form-group>
              </b-col>
              <b-col cols="md-6" />
            </template>

            <b-col cols="md-12">
              <b-form-group
                label="Announcement content*"
                label-for="h-announcement-title"
                label-cols-md="2"
              >
                <quill-editor
                  ref="quillTextEditor"
                  class="editor d-block"
                  :value="content"
                  :options="editorOption"
                  @change="onEditorChange"
                />
                <small
                  v-if="contentValidation"
                  class="text-danger"
                >
                  {{ contentError }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="cancelCreation()"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="saveAsDraft()"
            >
              Save as Draft
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-if="canViewThisAction('publish', 'Announcement')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="success"
              :disabled="content != '' ? invalid : true"
              @click="submitAndPublish()"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span class="align-middle">Save and Publish</span>
            </b-button>

            <b-button
              v-else
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="success"
              :disabled="content != '' ? invalid : true"
              @click="saveAsPending()"
            >
              <feather-icon
                icon="FlyIcon"
                class="mr-50"
              />
              <span class="align-middle">Submit for Verification</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BAlert, BFormRadioGroup, BFormRadio, BImg, BFormFile,
  BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BAlert,
    BFormRadioGroup,
    BFormRadio,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupAppend,

    quillEditor,
    vSelect,
    flatPickr,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: store.state.auth.userData,
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      image: null,
      fileSrc: '',
      fileName: '',
      category: [],
      department: [],
      user: [],
      toAgents: [],
      title: '',
      content: '',
      status: 'published',
      highlight: 'no',
      start: '',
      end: '',
      imageError: 'Valid image is required',
      imageValidation: false,
      fileError: '',
      categoryError: 'Valid category is required',
      titleError: 'Valid title is required',
      contentError: 'Valid content is required',
      categoryValidation: false,
      titleValidation: false,
      contentValidation: false,
      statusValidation: false,
      statusError: 'Valid status is required',
      highlightError: 'Valid highlight is required',
      highlightValidation: false,
      departmentError: 'Valid department is required',
      departmentValidation: false,
      userError: 'Valid user is required',
      userValidation: false,
      toAgentsError: 'Valid Department is required',
      toAgentsValidation: false,
      startError: 'Valid start is required',
      startValidation: false,
      endError: 'Valid end is required',
      endValidation: false,
      statusOptions: [
        { title: 'Active', code: 'active' },
        { title: 'Inactive', code: 'inactive' },
      ],
      requiredOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],
      trueFalseOptions: [{ title: 'Yes', code: 'yes' }, { title: 'No', code: 'no' }],

      categoryOptions: [],
      userOptions: [],
      departmentOptions: [],
      allDepartmentOptions: [],
      rankOptions: [],

      // validation rules
      required,
    }
  },
  beforeMount() {
    this.$http.get('customer/announcements/respond-with/category-options')
      .then(response => {
        this.categoryOptions = response.data.categoryOptions || []
        this.allDepartmentOptions = response.data.departmentOptions || []
        this.departmentOptions = this.userData.department
        this.userOptions = response.data.userOptions || []
        this.rankOptions = response.data.agentRanks || []
        if (this.$route.query.category) {
          this.categories = [this.$route.query.category]
        }
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    canViewThisAction,
    setImage() {
      if (this.image) {
        if (this.image && this.image.size <= 5242880) {
          const reader = new FileReader()
          reader.readAsDataURL(this.image)
          reader.onload = () => {
            this.fileSrc = reader.result
            this.fileError = ''
            this.fileName = this.image.name
          }
        } else {
          this.fileSrc = null
          this.fileName = ''
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'File size not accepted more than 5MB',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      }
    },
    removeFileSrc() {
      this.fileSrc = null
      this.image = null
      this.fileName = ''
    },
    cancelCreation() {
      this.$swal({
        title: 'Are You Sure?',
        html: 'Selecting Cancel will <strong>Erase all progress.</strong> This action cannot be undone!',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'No, go back',
        allowOutsideClick: false,
        confirmButtonText: 'Yes, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 461,
      })
        .then(result => {
          if (result.value) {
            this.$router.go(-1)
            // this.$router.push({ name: 'agencies-announcements-index', params: { type: 'all-announcement' } })
          }
        })
    },
    saveAsDraft() {
      this.status = 'draft'
      this.submitForm()
    },
    submitAndPublish() {
      this.$swal({
        title: 'Save and publish this announcement',
        html: "Please review the content carefully before publishing, as this will be reflected in the announcement once it's live. You can edit or make changes at any time in the future.",
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/volt.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'No, go back',
        allowOutsideClick: false,
        confirmButtonText: 'Yes, proceed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 498,
      })
        .then(result => {
          if (result.value) {
            this.submitForm()
          }
        })
    },
    saveAsPending() {
      this.$swal({
        title: 'Pending Verification',
        html: 'Your submission will be reviewed by the Business Development team for verification. Please carefully review the content before submitting.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/time.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'No, go back',
        allowOutsideClick: false,
        confirmButtonText: 'Yes, submit for verification',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 498,
      })
        .then(result => {
          if (result.value) {
            this.status = 'pending'
            this.submitForm()
          }
        })
    },
    onEditorChange(value) {
      this.content = value.html
    },
    submitForm() {
      this.$refs.announcementCreateForm.validate().then(async success => {
        if (success) {
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
          const formData = new FormData()

          if (this.image) {
            const res = await this.uploadFileToAws(this.image)
            const { fileUrl, fileName, upload } = res
            if (upload && fileUrl) {
              formData.append('image', fileName)
              formData.append('imageStorage', 'aws')
            } else {
              formData.append('highlightImage', this.image)
            }
          }
          formData.append('categories', JSON.stringify(this.category))
          formData.append('departments', JSON.stringify(this.department))
          formData.append('toAgents', JSON.stringify(this.toAgents))
          formData.append('title', this.title)
          formData.append('highlight', this.highlight)
          formData.append('start', this.start)
          formData.append('end', this.end)
          // formData.append('image', this.fileSrc)
          formData.append('fileName', this.fileName)
          formData.append('content', this.content)
          formData.append('status', this.status)

          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)

          this.$http.post('customer/announcements/store', formData)
            .then(response => {
              // this.$swal({
              //   title: 'Announcement Created',
              //   html: `New announcement <strong>${this.title}</strong> has been created successfully.`,
              //   // eslint-disable-next-line global-require
              //   imageUrl: require('@/assets/images/icons/save.png'),
              //   imageWidth: 80,
              //   imageHeight: 80,
              //   imageAlt: 'Custom Icon',
              //   showCancelButton: true,
              //   reverseButtons: true,
              //   cancelButtonText: 'Return to Announcements',
              //   allowOutsideClick: false,
              //   confirmButtonText: 'View Entry',
              //   customClass: {
              //     confirmButton: 'btn btn-primary ml-1',
              //     cancelButton: 'btn btn-outline-primary',
              //   },
              //   buttonsStyling: false,
              //   width: 550,
              // })
              //   .then(result => {
              //     if (result.value) {
              //       this.$router.push({ name: 'agencies-announcements-show', params: { id: response.data.data._id } })
              //     } else {
              //       this.$router.push({ name: 'agencies-announcements-index', params: { type: 'all-announcement' } })
              //     }
              //   })
              if (this.status === 'draft') {
                const toastMessage = `The announcement "<span class="text-bold-black">${this.title}</span>" has been successfully saved as a draft.`
                this.$toast({
                  component: ToastificationContentCustom,
                  props: {
                    title: 'Saved as draft',
                    text: toastMessage,
                    icon: 'CheckCircleIcon',
                    variant: 'info',
                    hideClose: true,
                  },
                })
              } else if (this.status === 'published') {
                const toastMessage = `The announcement "<span class="text-bold-black">${this.title}</span>" has been successfully created.`
                this.$toast({
                  component: ToastificationContentCustom,
                  props: {
                    title: 'Announcement Created',
                    text: toastMessage,
                    icon: 'CheckCircleIcon',
                    variant: 'success',
                    hideClose: true,
                  },
                })
              } else {
                const toastMessage = `The announcement "<span class="text-bold-black">${this.title}</span>" has been successfully sent for verification.`
                this.$toast({
                  component: ToastificationContentCustom,
                  props: {
                    title: 'Sent for verification',
                    text: toastMessage,
                    icon: 'CheckCircleIcon',
                    variant: 'warning',
                    hideClose: true,
                  },
                })
              }

              this.$router.push({ name: 'agencies-announcements-show', params: { id: response.data.data._id } })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'categories') {
                    this.categoryError = validationError.msg
                    this.categoryValidation = true
                  } else if (validationError.param === 'title') {
                    this.titleError = validationError.msg
                    this.titleValidation = true
                  } else if (validationError.param === 'content') {
                    this.contentError = validationError.msg
                    this.contentValidation = true
                  } else if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
  setup() {
    const editorOption = {
      modules: {
        // toolbar: '#quill-editor',
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ['clean'],
          ['link', 'image', 'video'],
        ],
      },
      theme: 'snow',
      placeholder: '',
    }

    return {
      editorOption,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
 .editor {
      min-height: 450px;
      overflow: hidden;
      border: 1px solid #D2DCEA;
      border-radius: 5px;
  }
</style>
